import { create } from '@mos-utils/acs-fetch';

const request = create((...parameters) =>
  fetch(...parameters).then(response => response.json())
);

export default request;
